import { type QueryHookOptions, useQuery } from "@apollo/client";
import { AnalyticsViewsByCityQuery } from "../graphql/queries";
import type {
  AnalyticsViewsByCityQueryType,
  AnalyticsViewsByCityQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useAnalyticsViewsByCityQuery = (
  options?: QueryHookOptions<
    AnalyticsViewsByCityQueryType,
    AnalyticsViewsByCityQueryVariablesType
  >
) => {
  return useQuery<
    AnalyticsViewsByCityQueryType,
    AnalyticsViewsByCityQueryVariablesType
  >(AnalyticsViewsByCityQuery, options);
};
